"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (ohlc1, ohlc2) {
    return !ohlc1 && ohlc1 === ohlc2 || !!ohlc1 && !!ohlc2 && ohlc1.epoch === ohlc2.epoch && ohlc1.close === ohlc2.close;
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/ticks/doCandleEqual.js
// module id = 27
// module chunks = 0